import { render, staticRenderFns } from "./GlobalPromoConfig.vue?vue&type=template&id=2d87226b"
import script from "./GlobalPromoConfig.vue?vue&type=script&lang=js"
export * from "./GlobalPromoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports